import { render } from "./Header.vue?vue&type=template&id=922a49c4&bindings={\"userSettings\":\"setup\",\"search\":\"props\",\"checked\":\"props\"}"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script